import {
  fetchWithErrorHandling,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {useMutation} from '@github-ui/react-query'
import {useMarkersActions, usePullRequestBasePath} from '../stores/selectors'
import type {FileKey, LineKey} from '@github-ui/diff-lines/types'
import {getCurrentUserLogin} from '@github-ui/client-env'
import {useThreadCountActions} from '../page-data/loaders/use-tab-counts'

export function useResolveThreadMutation(filePath: string, lineMarkersKey: LineKey | FileKey) {
  const basePath = usePullRequestBasePath()
  const currentUserLogin = getCurrentUserLogin()
  const apiUrl = `${basePath}/page_data/${PageData.resolveThread}`
  const {updateThread} = useMarkersActions()
  const {countThreadResolved} = useThreadCountActions()

  return useMutation({
    mutationFn: async ({threadId, resolutionReason}: {threadId: string; resolutionReason?: string}) => {
      const response = await fetchWithErrorHandling(apiUrl, {
        method: 'POST',
        body: {
          threadId,
          resolution_reason: resolutionReason,
        },
      })

      throwErrorsIfBadResponse(response)
    },
    onSuccess: (_data, variables) => {
      updateThread(Number(variables.threadId), filePath, lineMarkersKey, oldThread => {
        if (oldThread) {
          return {
            ...oldThread,
            isResolved: true,
            resolvedBy: currentUserLogin,
            resolutionReason: variables.resolutionReason,
          }
        }
      })

      countThreadResolved()
    },
  })
}
